export enum ActorType {
  // A white hat individual hacker
  Individual = 'Individual',
  // Either a white hat company like pen testers
  // or a compromised company like a supplier
  Company = 'Company',
  // A white hat research group
  ResearchGroup = 'ResearchGroup',
  // A white/black hat activist group
  Hacktivists = 'Hacktivists',
  // A white/black hat nation state or nation sponsored agency
  NationState = 'NationState',
  // A black hat group like ransom war gangs
  CriminalGroup = 'CriminalGroup',
  // A black hat terrorist group
  TerroristGroup = 'TerroristGroup',
  // An individual or group of thrill seekers like script kiddies
  ThrillSeekers = 'ThrillSeekers',
  // The actor is unknown
  Unknown = 'Unknown',
  // The actor is a broker that offers access to information they don't claim to have acquired themselves
  InitialAccessBroker = 'InitialAccessBroker',
}

export const ActorTypeDescriptor = Object.freeze({
  [ActorType.Individual]: 'Individual',
  [ActorType.Company]: 'Company',
  [ActorType.ResearchGroup]: 'Research Group',
  [ActorType.Hacktivists]: 'Hacktivists',
  [ActorType.NationState]: 'Nation State',
  [ActorType.CriminalGroup]: 'Criminal Group',
  [ActorType.TerroristGroup]: 'Terrorist Group',
  [ActorType.ThrillSeekers]: 'Thrill Seekers',
  [ActorType.Unknown]: 'Unknown',
  [ActorType.InitialAccessBroker]: 'Initial Access Broker',
});
